module.exports = __webpack_public_path__ + "images/statementsIcon-f3461929bf866a07ca32fe18edffb650.svg";